import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M485.3 470.623H14.7c-8.13 0-14.7 6.57-14.7 14.678 0 8.13 6.57 14.7 14.7 14.7h470.622c8.13 0 14.677-6.57 14.677-14.678 0-8.13-6.57-14.7-14.7-14.7zM250 0c-8.13 0-14.678 6.57-14.678 14.678v316.86l-53.128-53.283a14.63 14.63 0 0 0-20.786 0 14.63 14.63 0 0 0 0 20.785l78.287 78.44c.154.153.461.307.615.46 1.253 1.1 2.659 2.198 4.065 2.813 1.714.791 3.757 1.099 5.625 1.099 2.021 0 3.91-.462 5.625-1.099 1.714-.79 3.427-1.868 4.68-3.12l78.439-78.439a14.63 14.63 0 0 0 0-20.785 14.63 14.63 0 0 0-20.786 0l-53.283 53.282V14.702c0-8.13-6.548-14.7-14.677-14.7z" }, null, -1)
  ])))
}
export default { render: render }